import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

const Partner = () => {
  return (
    <div className="partner-usa p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                        <div className="partner_content">
                                <h2>Upgrade Your Application with the Best Mobile App Support</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                       <p>Here at TekRevol, we take pride in providing the most reliable mobile app maintenance services. Facilitating multiple businesses around the globe, we have earned a reputation in the industry for our flawless support. That’s why we have been a prior choice for various levels of organizations.</p>
                    </Col>
                </Row>
                <Row className="h-100 partner_padd">
                <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
                    <div className="partner-num">
                    4.8
                    </div>
                    <div className="partner-para">
                        <p>Average Clutch Rating</p>
                    </div>
                </Col> 
                <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
                    <div className="partner-num">
                    10th
                    </div>
                    <div className="partner-para">
                        <p>Ranked on RightFirms</p>
                    </div>
                </Col> 
                <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
                    <div className="partner-num">
                         4.4
                    </div>
                    <div className="partner-para">
                        <p>Average Google Play Rating</p>
                    </div>
                </Col> 
                </Row>
            </Container>
    </div>
  )
}

export default Partner